import React, { useState } from 'react';
import { Campaign } from '../../../../../model/campaign/Campaign';
import { CampaignService } from '../../service';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../store/authentication/authRedux';
import { CampaignHeaderButtons } from '../../components/CampaignHeaderButtons';
import { CampaignChangeMobile } from '../../components/CampaignChangeMobile';

interface ICampaignMobileMenu {
    campaign: Campaign;
    setCampaign: (arg: any) => void;
}

export default function CampaignMobileMenu({ campaign, setCampaign }: ICampaignMobileMenu) {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);

    const addToShortcuts = (id?: number) => {
        CampaignService.addToShortcuts(id ?? 0).then(response => {
            dispatch(actions.updateFavoriteCampaign(response));
            setCampaign({ ...campaign!, isFavorite: !campaign?.isFavorite });
        });
    };

    return (
        <div className="d-md-none align-items-center justify-content-between mb-4 position-relative">
            <h5 className="m-0">{campaign?.title ?? '-'}</h5>
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <div className={`status w-max-content ${campaign?.status}`}>{campaign?.status}</div>
                    {/*<div>{formatDate(campaign?.publishFrom)}- {formatDate(campaign?.publishTo)}</div>*/}
                </div>
                <div className="d-flex align-items-center justify-content-sm-around mt-2 mt-sm-0">
                    <CampaignHeaderButtons setShow={setShow} campaign={campaign} addToShortcuts={addToShortcuts} />
                </div>

                {show && <CampaignChangeMobile setShow={setShow} />}
            </div>
        </div>
    );
}
